// extracted by mini-css-extract-plugin
module.exports = {"header":"items_list_header__1QBCf","item":"items_list_item__1j3LN"};